import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { FormHelperText, Icon } from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useNotification } from "context/notification.context";
import { getUserRoles, addUser } from "network/service";
import Autocomplete from "@mui/material/Autocomplete";

export default function AddUserDetails(props) {
    const [newField, setNewField] = useState({ username: "", password: "", email: "" });
    const [errors, setErrors] = useState({});
    const { showNotification } = useNotification();
    const [roles, setRoles] = useState([]);
    const [selRole, setSelRole] = useState(null);
    const [loading, setLoading] = useState(false);

    const validate = () => {
        let isValid = true;
        let newErrors = {};

        if (newField.username.trim() === "") {
            newErrors = { ...newErrors, username: "Username is required" };
            isValid = false;
        }
        if (newField.password.trim() === "") {
            newErrors = { ...newErrors, password: "Password is required" };
            isValid = false;
        }
        if (newField.email.trim() === "") {
            newErrors = { ...newErrors, email: "Email is required" };
            isValid = false;
        }
        if (!selRole) {
            isValid = false;
            newErrors = { ...newErrors, role: "Select a valid User role" };
        }
        setErrors(newErrors);
        return isValid;
    }

    const submit = async () => {
        try {
            const isValid = validate();

            if (isValid) {
                setLoading(true);
                if (props.details && props.details._id) {
                    console.log("Updating Branch with id:", props.details._id);
                    // showNotification("success", "Success", "Updated the Branch Details successfully");
                    props.handlesuccess();
                } else {
                    console.log("Adding new Branch");
                    await addUser({ username: newField.username, password: newField.password, role: selRole._id, email: newField.email });
                    showNotification("success", "Success", "Added the User Details successfully");
                    props.handlesuccess();
                }
                setLoading(false);
                props.handleclose();
            }
        } catch (err) {
            console.error("Error adding/updating branch:", err);
            setLoading(false);
            showNotification("error", "Error", "Failed to add User.");
        }
    };

    useEffect(() => {
        console.log("props.details:", props.details);
        if (props.details) {
            console.log("Setting newField with props.details:", props.details);

        }
    }, [props.details]);

    useEffect(() => {
        getUserRoles().then((resp) => {
            setRoles(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }, [setRoles])


    return (
        <Dialog
            id="modal-display"
            open={props.isopen}
            aria-labelledby="form-dialog-title"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            maxHeight="90%"
            onClose={props.handleclose}
            disableBackdropClick
        >
            <div>
                <DialogTitle>{props.details ? 'Edit Branch' : 'Add Branch'}</DialogTitle>
            </div>
            <DialogContent sx={{ minWidth: 500 }}>
                <Grid container direction="column" spacing={2}>
                    <Grid item >
                        <MDInput
                            label="UserName"
                            value={newField.username}
                            disabled={props.details}
                            fullWidth
                            onChange={(e) => {
                                setNewField({
                                    ...newField,
                                    username: e.target.value
                                });
                            }}
                            helperText={<FormHelperText sx={{ color: 'red', fontWeight: 800, margin: 0 }}>{errors.username}</FormHelperText>}
                        // helperText={
                        //     <FormHelperText sx={{ color: '#FF0000', fontWeight: 800, margin: 0 }}>
                        //         {errors.name && "Customer Name is required"}
                        //     </FormHelperText>
                        // }
                        />

                    </Grid>
                    <Grid item>
                        <MDInput
                            fullWidth
                            disabled={props.details}
                            label="Email"
                            value={newField.email}
                            helperText={<FormHelperText sx={{ color: 'red', fontWeight: 800, margin: 0 }}>{errors.email}</FormHelperText>}
                            onChange={(e) => {
                                setNewField({
                                    ...newField,
                                    email: e.target.value
                                });
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <MDInput
                            fullWidth
                            disabled={props.details}
                            label="Password"
                            value={newField.password}
                            helperText={<FormHelperText sx={{ color: 'red', fontWeight: 800, margin: 0 }}>{errors.password}</FormHelperText>}
                            onChange={(e) => {
                                setNewField({
                                    ...newField,
                                    password: e.target.value
                                });
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <Autocomplete
                            label={"Role"}
                            sx={{ flexGrow: 1 }}
                            error={errors.role}
                            options={roles}
                            getOptionLabel={(option) => option.name || ''}
                            renderInput={(params) => <MDInput {...params} label={"Role"} fullWidth />}
                            onChange={(event, newValue) => {
                                setSelRole(newValue);
                            }}
                            value={selRole}
                        />
                        {(errors.role) && (
                            <FormHelperText sx={{ color: 'red', fontWeight: 800, marginLeft: 1 }}>
                                {errors.role}
                            </FormHelperText>
                        )}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <MDButton variant="gradient" color="error" onClick={props.handleclose}>
                    <Icon>close</Icon>&nbsp;
                    Cancel
                </MDButton>
                <MDButton variant="gradient" color="success" onClick={submit}>
                    <Icon>save</Icon>&nbsp;
                    Save
                </MDButton>

            </DialogActions>
        </Dialog>
    )
}
